export default __webpack_public_path__ + "static/media/Plat-Tunisien.aa0b15be.png";